module.exports = __webpack_public_path__ + "img/point.bc5888f5.png";